export * from '@sayyoo/services-modifydata';



//////////////////
// WEBPACK FOOTER
// ./~/@sayyoo/services-http-apis/lib/modifydata.js
// module id = kCp9
// module chunks = 256